export default "__VITE_ASSET__DoK$Vhjj__"